import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Ausbildungsnachweise from '#components/svg/icons/NavAusbildungsnachweise'
import Ausbildungsplan from '#components/svg/icons/NavAusbildungsplan'
import StatusUebersicht from '#components/svg/icons/NavStatusUebersicht'
import NavigationButton from '../../a/NavigationButton'
import {routeHelper} from '../../../config/routeKeys'
import {useNavigate} from "react-router-dom";

export const SearchResultNavigationButtons = ({azubi, onNavigationButtonClick}) => {
  const navigate = useNavigate()
  const handleClickRoute = routeTo => {
    navigate(routeTo)
    onNavigationButtonClick()
  }

  return (
    <div className="searchResultNavigationButtons">
      <NavigationButton
        navigationFunction={() => handleClickRoute(routeHelper.ausbildungsnachweisePerUser(azubi.id))}
        text={i18n.t('ausbildungsnachweiseOverview_headline')}
        SvgIcon={<Ausbildungsnachweise/>}
      />
      <NavigationButton
        navigationFunction={() => handleClickRoute(routeHelper.ausbildungsplanForUser(azubi.id))}
        text={i18n.t('menu_item_ausbildungsplan')}
        SvgIcon={<Ausbildungsplan/>}
      />
      <NavigationButton
        navigationFunction={() => handleClickRoute(routeHelper.praxisaufgabenDetail(azubi.id))}
        text={i18n.t('menu_item_praxisaufgabenOverview')}
        SvgIcon={<StatusUebersicht/>}
      />
    </div>
  )
};

SearchResultNavigationButtons.propTypes = {
  azubi: PropTypes.object,
  onNavigationButtonClick: PropTypes.func,
}

export default SearchResultNavigationButtons
